import React, { useState } from 'react';
import { 
  Box, 
  Button, 
  Dialog, 
  DialogContent, 
  DialogTitle, 
  IconButton,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// Use environment variable for Calendly URL with a fallback
const CALENDLY_URL = process.env.REACT_APP_CALENDLY_URL || 'https://calendly.com/ericrak-dev/30min';

const CalendlyBooking = ({ buttonText = "Book a Call", buttonProps = {} }) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="contained"
        onClick={handleOpen}
        {...buttonProps}
      >
        {buttonText}
      </Button>
      
      <Dialog
        open={open}
        onClose={handleClose}
        fullScreen={fullScreen}
        maxWidth="md"
        fullWidth
        aria-labelledby="booking-dialog-title"
        PaperProps={{
          sx: { 
            borderRadius: { xs: 0, sm: 3 },
            height: { xs: '100%', sm: '80vh' }
          }
        }}
      >
        <DialogTitle id="booking-dialog-title" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" component="div">
            Schedule a Free Consultation
          </Typography>
          <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0, height: '100%' }}>
          <Box sx={{ height: '100%', width: '100%' }}>
            {/* Calendly inline widget */}
            <iframe
              src={CALENDLY_URL}
              width="100%"
              height="100%"
              frameBorder="0"
              title="Schedule a call"
              style={{ minHeight: '650px' }}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CalendlyBooking; 